import { render, staticRenderFns } from "./VlDatePickerSmall.vue?vue&type=template&id=8d4fe462&"
import script from "./VlDatePickerSmall.vue?vue&type=script&lang=js&"
export * from "./VlDatePickerSmall.vue?vue&type=script&lang=js&"
import style0 from "./VlDatePickerSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports